/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, June 30th 2022, 11:20:47 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */
import { LogOut } from "react-feather";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { ADMIN_PORTAL_DEPLOYMENT_MODE } from "config";
import { URLS } from "core/routes";
import { OrganizationListItem } from "lib/schemas";
import { COLORSCHEME } from "theme/styles";
import { StyledOSDialog, useToggleState, OSAvatar, OSActionButton } from "ui-widgets";
import { OrganizationSwitcherGridList, OrganizationSwitcherGridListProps } from "./OrganizationSwitcherGridList";

export const OrganizationSwitcherButtonSelector = ({
  selectedOrganization,
  switchOrganization,
}: OrganizationSwitcherGridListProps) => {
  const { open, handleClose, handleOpen } = useToggleState();

  const handleSwitchOrganization = (organizationListItem: OrganizationListItem) => {
    switchOrganization(organizationListItem);
    handleClose();
  };

  const showAddOrganizationButton = ADMIN_PORTAL_DEPLOYMENT_MODE === "SAAS";

  return (
    <>
      <button className="os-org-modal-button" onClick={handleOpen}>
        <OSAvatar
          name={selectedOrganization?.name}
          imageSrc={selectedOrganization?.logo}
          variant="rounded"
          sx={{ width: 28, height: 28 }}
        />
        {selectedOrganization?.name}
        <ChevronRightIcon />
      </button>

      <StyledOSDialog
        popUpIcon={<LogOut color={COLORSCHEME.primaryVariant} />}
        maxWidth="sm"
        popUpTitle="Your Organizations"
        open={open}
        onClose={handleClose}
      >
        <Stack direction="row" justifyContent="space-between" className="os-modal-header-style-1">
          <Typography variant="h6"></Typography>
          {showAddOrganizationButton ? (
            <OSActionButton actionStyle="add" to={URLS.setup} variant="contained">
              Add Organization
            </OSActionButton>
          ) : null}
        </Stack>
        <div className="os-org-list-wrapper">
          <OrganizationSwitcherGridList
            switchOrganization={handleSwitchOrganization}
            selectedOrganization={selectedOrganization}
          />
        </div>
      </StyledOSDialog>
    </>
  );
};
